import { render, staticRenderFns } from "./DefensasPage.vue?vue&type=template&id=40bcb15d"
import script from "./DefensasPage.js?vue&type=script&lang=js&external"
export * from "./DefensasPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports